// Product Variant Selector - EXACT COPY from reference theme ap-theme.js
(function () {
    'use strict';

    // Debounce timer for variant updates
    let variantUpdateTimeout = null;
    
    function init() {
        const form = document.getElementById('product-form');

        if (!form) {
            return;
        }

        // Listen for option changes with debouncing
        form.addEventListener('change', function (e) {
            if (e.target.name && e.target.name.startsWith('option')) {
                // Clear any pending update
                if (variantUpdateTimeout) {
                    clearTimeout(variantUpdateTimeout);
                }
                
                // Debounce the update to prevent rapid changes
                variantUpdateTimeout = setTimeout(function() {
                    updateVariant();
                }, 100); // Small delay for smoother UX
            }
        });

        // Initial update
        updateVariant();
    }

    // EXACT logic from working theme ap-theme.js line 7881-7886
    function getSelectedOptionValues() {
        const options = [];
        const form = document.getElementById('product-form');
        if (!form) return options;

        // Get all checked radio inputs and select elements with name starting with "option"
        const optionInputs = form.querySelectorAll('input[name^="option"]:checked, select[name^="option"]');
        optionInputs.forEach(function (option) {
            options.push(option.value);
        });

        return options;
    }

    // EXACT logic from working theme ap-theme.js line 7863-7879
    function getFirstMatchingAvailableVariant() {
        if (typeof window.productVariants === 'undefined') {
            return null;
        }

        let options = getSelectedOptionValues();
        let matchedVariant = null;
        let slicedCount = 0;

        do {
            options.pop();
            slicedCount += 1;

            matchedVariant = window.productVariants.find(function (variant) {
                return (
                    variant.available &&
                    variant.options
                        .slice(0, variant.options.length - slicedCount)
                        .every(function (value, index) {
                            return value === options[index];
                        })
                );
            });
        } while (!matchedVariant && options.length > 0);

        return matchedVariant;
    }

    function updateVariant() {
        const variantField = document.getElementById('variant-id');
        if (!variantField) {
            return;
        }

        const selected = getSelectedOptionValues();

        // Find exact match first
        if (typeof window.productVariants !== 'undefined') {
            for (let variant of window.productVariants) {
                const variantOpts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);

                if (selected.length === variantOpts.length &&
                    selected.every((val, i) => val === variantOpts[i])) {
                    variantField.value = variant.id;

                    // Update price
                    updatePrice(variant);

                    // Update labels
                    updateLabels(selected);

                    // Update image if variant has an image
                    updateImage(variant);

                    return;
                }
            }

            // Fallback to working theme's matching logic
            const matchedVariant = getFirstMatchingAvailableVariant();
            if (matchedVariant) {
                variantField.value = matchedVariant.id;
                updatePrice(matchedVariant);
                updateLabels(selected);
                updateImage(matchedVariant);
            }
        }
    }

    function updatePrice(variant) {
        if (variant && variant.price) {
            const price = '$' + (variant.price / 100).toFixed(2);
            document.querySelectorAll('.bb-product-price').forEach(el => {
                el.textContent = price;
            });
        }
    }

    function updateLabels(selectedOptions) {
        const form = document.getElementById('product-form');
        if (!form) return;

        selectedOptions.forEach((val, i) => {
            const radio = form.querySelector(`input[name="option${i + 1}"]:checked`);
            if (radio && radio.dataset.bindValue) {
                const labelEl = document.getElementById(radio.dataset.bindValue);
                if (labelEl) {
                    labelEl.textContent = val;
                }
            }
        });
    }

    // Image cache for faster loading (make it global so other scripts can access it)
    window.imageCache = window.imageCache || new Map();
    const imageCache = window.imageCache;
    
    function updateImage(variant) {
        if (!variant) return;

        const mainImageContainer = document.querySelector('#main-product-image');
        const mainImage = mainImageContainer ? mainImageContainer.querySelector('img') : null;
        const loader = mainImageContainer ? mainImageContainer.querySelector('.bb-product-main-image__loader') : null;
        
        if (!mainImage) return;

        // Check if variant has a featured_image or featured_media
        let variantImageUrl = null;
        
        // Check featured_media (Shopify standard)
        if (variant.featured_media) {
            if (typeof variant.featured_media === 'object') {
                // featured_media.src or featured_media.preview_image.src
                variantImageUrl = variant.featured_media.src || 
                                 (variant.featured_media.preview_image && variant.featured_media.preview_image.src);
            } else if (typeof variant.featured_media === 'string') {
                variantImageUrl = variant.featured_media;
            }
        }
        // Check featured_image (alternative property)
        else if (variant.featured_image) {
            if (typeof variant.featured_image === 'object' && variant.featured_image.src) {
                variantImageUrl = variant.featured_image.src;
            } else if (typeof variant.featured_image === 'string') {
                variantImageUrl = variant.featured_image;
            }
        }
        // Check variant.image property (some Shopify setups use this)
        else if (variant.image) {
            if (typeof variant.image === 'object' && variant.image.src) {
                variantImageUrl = variant.image.src;
            } else if (typeof variant.image === 'string') {
                variantImageUrl = variant.image;
            }
        }
        
        // Fallback: Try to find matching media based on variant options
        if (!variantImageUrl && typeof window.productMedia !== 'undefined' && Array.isArray(window.productMedia) && window.productMedia.length > 0) {
            const variantOptions = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
            
            // Try to find media that matches variant option values (like color)
            // Check media alt text for matches
            for (let i = 0; i < window.productMedia.length; i++) {
                const media = window.productMedia[i];
                const mediaAlt = (media.alt || '').toLowerCase();
                
                // Check if any variant option matches media alt text
                for (let j = 0; j < variantOptions.length; j++) {
                    const optionValue = (variantOptions[j] || '').toLowerCase().trim();
                    if (optionValue && (mediaAlt.includes(optionValue) || optionValue.includes(mediaAlt))) {
                        variantImageUrl = media.src;
                        break;
                    }
                }
                
                if (variantImageUrl) break;
            }
            
            // If still no match and we have options, try matching by position/index
            if (!variantImageUrl && variantOptions.length > 0) {
                // Try to match first color option with media position
                const firstOption = variantOptions[0];
                if (firstOption) {
                    // Check if we can match by media position (assuming first option is color)
                    const mediaIndex = window.productMedia.findIndex(function(m) {
                        const alt = (m.alt || '').toLowerCase();
                        return alt.includes(firstOption.toLowerCase()) || alt.includes(firstOption.toLowerCase().replace(/\s+/g, '-'));
                    });
                    if (mediaIndex >= 0) {
                        variantImageUrl = window.productMedia[mediaIndex].src;
                    }
                }
            }
            
            // Last resort: use first media as fallback
            if (!variantImageUrl && window.productMedia.length > 0) {
                variantImageUrl = window.productMedia[0].src;
            }
        }

        // If we found an image, update the main image
        if (variantImageUrl) {
            // Convert Shopify CDN URL to larger size if needed
            // Shopify URLs format: https://cdn.shopify.com/.../image.jpg?v=1234567890
            // We want to get a larger version (800px width)
            let finalUrl = variantImageUrl;
            
            // Try to get a larger version of the image
            // Remove existing size parameters and add width parameter
            if (variantImageUrl.includes('cdn.shopify.com')) {
                // Check if URL already has size parameters
                if (variantImageUrl.match(/_(small|medium|large|grande|master|\d+x\d+)\./)) {
                    // Replace existing size with 800x
                    finalUrl = variantImageUrl.replace(/_(small|medium|large|grande|master|\d+x\d+)\./, '_800x.');
                } else {
                    // Add size parameter before file extension
                    finalUrl = variantImageUrl.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_800x.$1');
                }
            } else {
                // For non-Shopify CDN URLs, try to add size parameter
                finalUrl = variantImageUrl.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_800x.$1');
            }
            
            // Get current image source for comparison
            const currentSrc = mainImage.src || mainImage.getAttribute('src') || '';
            
            // Simple check - only update if URL is different
            // Normalize URLs by removing query params for comparison
            const currentNormalized = currentSrc.split('?')[0];
            const finalNormalized = finalUrl.split('?')[0];
            
            // Only update if it's a different image
            if (currentNormalized !== finalNormalized && !currentNormalized.includes(finalNormalized.split('/').pop())) {
                // Show loader
                if (loader) {
                    loader.classList.add('active');
                }
                
                // Add loading class for fade effect
                mainImage.classList.add('loading');
                
                // Check cache first
                if (imageCache.has(finalUrl)) {
                    // Use cached image immediately
                    requestAnimationFrame(function() {
                        swapImage(mainImage, finalUrl, variant, loader);
                    });
                } else {
                    // Preload image with better error handling
                    const newImg = new Image();
                    
                    // Set up load handler
                    newImg.onload = function() {
                        // Cache the image
                        imageCache.set(finalUrl, true);
                        
                        // Use requestAnimationFrame for smooth transition
                        requestAnimationFrame(function() {
                            swapImage(mainImage, finalUrl, variant, loader);
                        });
                    };
                    
                    // Error handler - try fallback URL
                    newImg.onerror = function() {
                        // Try original URL if resized version fails
                        if (finalUrl !== variantImageUrl) {
                            const fallbackImg = new Image();
                            fallbackImg.onload = function() {
                                imageCache.set(variantImageUrl, true);
                                requestAnimationFrame(function() {
                                    swapImage(mainImage, variantImageUrl, variant, loader);
                                });
                            };
                            fallbackImg.onerror = function() {
                                // Hide loader on error
                                if (loader) {
                                    loader.classList.remove('active');
                                }
                                mainImage.classList.remove('loading');
                            };
                            fallbackImg.src = variantImageUrl;
                        } else {
                            // Hide loader on error
                            if (loader) {
                                loader.classList.remove('active');
                            }
                            mainImage.classList.remove('loading');
                        }
                    };
                    
                    // Start loading
                    newImg.src = finalUrl;
                }
            } else {
                // Update active thumbnail even if image didn't change
                updateActiveThumbnail(finalUrl);
            }
        }
    }
    
    function swapImage(imgElement, newSrc, variant, loader) {
        // Remove loading class
        imgElement.classList.remove('loading');
        
        // Update image source
        imgElement.src = newSrc;
        imgElement.alt = variant.title || imgElement.alt || 'Product image';
        
        // Add fade-in animation
        imgElement.classList.add('fade-in');
        
        // Remove fade-in class after animation completes
        setTimeout(function() {
            imgElement.classList.remove('fade-in');
        }, 400);
        
        // Hide loader
        if (loader) {
            loader.classList.remove('active');
        }
        
        // Update active thumbnail
        updateActiveThumbnail(newSrc);
    }
    
    function updateActiveThumbnail(imageUrl) {
        const thumbnails = document.querySelectorAll('.bb-product-thumbnail');
        thumbnails.forEach(thumb => {
            const thumbDataImage = thumb.dataset.image;
            if (thumbDataImage) {
                // Extract filename from URLs for comparison
                const thumbFilename = thumbDataImage.split('/').pop().split('?')[0];
                const imageFilename = imageUrl.split('/').pop().split('?')[0];
                
                // Check if thumbnail matches the variant image (by filename or full URL)
                if (thumbDataImage === imageUrl || 
                    thumbDataImage.includes(imageFilename) || 
                    imageUrl.includes(thumbFilename)) {
                    thumbnails.forEach(t => t.classList.remove('active'));
                    thumb.classList.add('active');
                }
            }
        });
    }

    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
